const Home = () => import('@/views/tbk/home') // 首页
const Search = () => import('@/views/tbk/search') // 搜索
const Mine = () => import('@/views/tbk/mine') // 我的

const ProductTkl = () => import('@/views/tbk/productTkl') // 商品淘口令
const ProductCollection = () => import('@/views/tbk/productCollection') // 商品收藏

const TaobaoAuth = () => import('@/views/tbk/taobaoAuth') // 淘宝账号授权登录
const TaobaoActivity = () => import('@/views/h5/taobaoActivity') // 淘宝活动页

const OrderQuery = () => import('@/views/tbk/orderQuery') // 订单查询

export default [
  { path: '/', name: 'home', component: Home, meta: { isTab: true, keepAlive: true, title: '领券专区', channel: 'tbk' } },
  { path: '/search', name: 'search', component: Search, meta: { isTab: true, keepAlive: true, title: '搜索' } },
  { path: '/mine', name: 'mine', component: Mine, meta: { isTab: true, keepAlive: true, requireAuth: false, title: '我的' } },
  { path: '/product/tkl', name: 'productTkl', component: ProductTkl, meta: { keepAlive: false, title: '今日优选' } },
  { path: '/product/collection', name: 'productCollection', component: ProductCollection, meta: { keepAlive: false, title: '商品收藏' } },
  { path: '/auth/taobao', name: 'taobaoAuth', component: TaobaoAuth, meta: { keepAlive: true, title: '淘宝账号授权登录' } },
  { path: '/h5/taobaoActivity', name: 'taobaoActivity', component: TaobaoActivity, meta: { keepAlive: true, requireAuth: true, title: '一元购' } },
  { path: '/order/query', name: 'orderQuery', component: OrderQuery, meta: { keepAlive: false, requireAuth: true, title: '订单查询' } },
]